import React from 'react';
import DirectionsCarIcon from '@mui/icons-material/DirectionsCar';
import './VehicleInQueue.css';

interface VehicleInQueueProps {
    vehicle: {
        licensePlate: string;
        model?: string;
    };
    queueNumber: number;
    position: number;
    userVehicle: string;
    estimatedWaitTime: number;
}

const VehicleInQueue: React.FC<VehicleInQueueProps> = ({ vehicle, position, userVehicle }) => {
    const isUserVehicle = vehicle.licensePlate === userVehicle;
    return (
    <div className="vehicle-card">
            <DirectionsCarIcon style={{ fontSize: 50, color: '#007BFF' }} />
            <span className="license-plate">
                {vehicle.licensePlate}
            </span>
            {vehicle.model && (
                <span className="model">{vehicle.model}</span>
            )}
            {isUserVehicle && (
                <span className="queue-position">
                    ( position: {position + 1})
                </span>
            )}
        </div>
    );
};

export default VehicleInQueue;
